import React from 'react'
import './month.css'
import {
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  format,
  addDays
} from "date-fns";
import { Link } from 'react-router-dom'

const Month = (props) => {
  const { days, currentMonth, currentYear } = props; 
  const  month  = new Date(currentYear,currentMonth);

  const src = {
    'Anger':'/playground_assets/angry-200h.png',
    'Disgust':'/playground_assets/sick-200h.png',
    'Fear':'/playground_assets/scare [1]-200h.png ',
    'Happiness':'/playground_assets/smiley-200h.png',
    'Neutral':'/playground_assets/confusing-200h.png',
    'Sadness':'/playground_assets/white simple letter m logo [1]-200h.png',
    'Surprise':'/playground_assets/surprised-200h.png'
  }

  return (
    <div className="month-container">
      <div className="month-container01 row">
        <h2 className="month-text6 col cell">Su</h2>
        <h2 className="month-text col cell">Mo</h2>
        <h2 className="month-text1 col cell">Tu</h2>
        <h2 className="month-text2 col cell">We</h2>
        <h2 className="month-text3 col cell">Th</h2>
        <h2 className="month-text4 col cell">Fr</h2>
        <h2 className="month-text5 col cell">Sa</h2>
      </div>
      <RenderCells month={month} days={days} src={src}/>
    </div>
  )
}

export default Month


const RenderCells = (props) => {
  const { month, days, src } = props;
  const monthStart = startOfMonth(month);
  const monthEnd = endOfMonth(monthStart);
  const startDate = startOfWeek(monthStart);
  const endDate = endOfWeek(monthEnd);

  const dateFormat = "d";
  const rows = [];

  let days_object = [];
  let day = startDate;
  let formattedDate = "";

  while (day <= endDate) {
    for (let i = 0; i < 7; i++) {
      formattedDate = format(day, dateFormat);
      let content = (
        <div className='col cell' key={day}>
          <span className="number">{formattedDate}</span>
          <span className="bg">{formattedDate}</span>
        </div>
      )
      for (let j =0; j < days.length; j++){
        if(days[j].day == formattedDate && days[j].month == day.getMonth()) {
          content = (
          <div className='col cell calendar-emotion' key={day}>
            <Link to={"/daily-phrase"}
              state= {{
                day: days[j].day,
                month: days[j].month
              }}
              className="nav-navlink" 
            >
              <img src={src[days[j].emotion]} />
            </Link>
          </div>
          );
        }
        
      }
      days_object.push(content);
      day = addDays(day, 1);
    }
    rows.push(
      <div className="row" key={day}>
        {days_object}
      </div>
    );
    days_object = [];
  }
  return (
    <div className='calendar'>
      <div className="body">
        {rows}
      </div>
    </div>
  );
}
